"use strict";
exports.__esModule = true;
exports.chart_bar_data_stroke = {
  "name": "--pf-chart-bar--data--stroke",
  "value": "none",
  "var": "var(--pf-chart-bar--data--stroke, none)"
};
exports["default"] = exports.chart_bar_data_stroke;